import * as React from 'react';
// @ts-expect-error
import type {ConnectDragSource} from 'react-dnd';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import {ERROR_TYPE_DELETING} from '../../dashboard-constants';

import {DashHeaderConfigButton} from './dash-header-config-button';

import styles from './dash-header.module.css';

type Props = {
    onConfigure?: () => void;
    isConfigurable: boolean;
    onRemove?: () => void;
    onDeleteDashConfirm?: () => void;
    isDeleteConfirming?: boolean;
    isRefreshingComponent?: boolean;
    subheader: string;
    title: string;
    error?: any;
    connectDragSource?: ConnectDragSource;
};

export class DashHeader extends React.Component<Props> {
    render() {
        const header = this.renderHeader();

        return this.props.connectDragSource ? this.props.connectDragSource(header) : header;
    }

    renderHeader = () => {
        const hasConfigButton = this.props.onRemove || this.props.onConfigure;

        return (
            <header className={styles.header}>
                {this.renderDashDescription(
                    this.props.title,
                    this.props.subheader,
                    this.props.error,
                    !hasConfigButton
                )}
                <div className={styles['button-container']}>
                    {this.props.isRefreshingComponent ? (
                        <div className={styles.refreshing}>
                            <LoadingIcon size={19} />
                        </div>
                    ) : undefined}
                    {hasConfigButton ? (
                        <DashHeaderConfigButton
                            onEdit={this.props.onConfigure}
                            onRemove={this.props.onRemove}
                            title={this.props.title}
                            isConfigurable={this.props.isConfigurable}
                            isDeleteConfirming={this.props.isDeleteConfirming}
                            onDeleteConfirm={this.props.onDeleteDashConfirm}
                        />
                    ) : undefined}
                </div>
            </header>
        );
    };

    renderDashDescription(
        title: string,
        subheader: string,
        error:
            | {
                  type: string;
              }
            | null
            | undefined,
        isWide: boolean
    ) {
        return (
            <div className={isWide ? styles['left-side-wide'] : styles['left-side']}>
                <div className={styles.description}>
                    <h2
                        className={
                            error && error.type !== ERROR_TYPE_DELETING
                                ? styles['dash-title--errored']
                                : styles['dash-title']
                        }
                    >
                        {title}
                    </h2>
                    <h3 className={styles['dash-subheader']}>{subheader}</h3>
                </div>
            </div>
        );
    }
}
